/**
 * Base FAQ Component
 */
export class BaseFaq {
    constructor() {
        // 기존 initBaseFaq 로직 유지
        if (typeof initBaseFaq === 'function') {
            initBaseFaq();
        }
    }
}

